import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@sopranodesign/pulse-hooks';

const isValid = (subject, spreadsheets) => {
  if (!subject.spreadsheet_id) {
    return true;
  }

  const spreadsheet = spreadsheets.find(
    ({ id }) => id === subject.spreadsheet_id
  );

  if (!spreadsheet) {
    return false;
  }

  if (
    subject.lookup_id &&
    !spreadsheet.lookups.some(({ id }) => id === subject.lookup_id)
  ) {
    return false;
  }

  return true;
};

const LookupValidator = ({ subject, onValidityChange }) => {
  const { data, isSuccess } = useQuery({
    queryKey: [
      'spreadsheets'
    ]
  });

  useEffect(() => {
    if (!isSuccess) {
      return;
    }

    onValidityChange(isValid(subject, data.data));
  }, [isSuccess, data, subject, onValidityChange]);

  return null;
};

LookupValidator.propTypes = {
  subject: PropTypes.object.isRequired,
  onValidityChange: PropTypes.func.isRequired
};

export default LookupValidator;
